import type { FolderApi } from 'tweakpane';

export function createListHandlerWithOptions(folderApi: FolderApi, target: string[], options: string[]): void {
  const arrayTemp = {
    value: options[0],
    displayValue: target.join(', '),
  };

  folderApi.addBinding(arrayTemp, 'displayValue', {
    label: 'Value',
    readonly: true,
  });
  folderApi.addBinding(arrayTemp, 'value', {
    options: Object.fromEntries(options.map((value) => [value, value])),
  });
  folderApi.addButton({ title: 'Add' }).on('click', () => {
    if (target.includes(arrayTemp.value)) return;
    target.push(arrayTemp.value);
    arrayTemp.displayValue = target.join(', ');
  });
  folderApi.addButton({ title: 'Remove' }).on('click', () => {
    if (!target.includes(arrayTemp.value)) return;
    target.splice(target.indexOf(arrayTemp.value), 1);
    arrayTemp.displayValue = target.join(', ');
  });
}
